"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeUrl = void 0;
function computeUrl(input, baseUrl) {
    if (typeof input !== "string")
        return input;
    var base = baseUrl || new URL(location.href);
    if (input.match(/^\/(?!\/)/)) {
        var path = input;
        return new URL(base.origin + path);
    }
    throw new Error("Invalid path " + input);
}
exports.computeUrl = computeUrl;
//# sourceMappingURL=computeUrl.js.map